/**
 * StatusFilterDropdown Component
 * 
 * Simple native select dropdown for filtering matches by application status.
 */

import React from 'react';

interface StatusFilterDropdownProps {
  selectedStatus: string | null;
  onChange: (status: string | null) => void;
  availableStatuses: Array<{ value: string; label: string }>;
}

const StatusFilterDropdown: React.FC<StatusFilterDropdownProps> = ({
  selectedStatus,
  onChange,
  availableStatuses
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    onChange(value === '' ? null : value);
  };

  return (
    <select
      value={selectedStatus || ''}
      onChange={handleChange}
      className="w-full px-3 py-1.5 text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      aria-label="Filter by application status"
    >
      <option value="">All Statuses</option>
      {availableStatuses.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default StatusFilterDropdown;
